"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticRenewalCheckboxWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var journey_services_1 = require("@athena-portal/journey-services");
var CollapseTextWidget_1 = require("../../../components/CollapseTextWidget");
var AutomaticRenewalCancellationConfirmationModal_1 = require("../../../components/modals/AutomaticRenewalCancellationConfirmationModal");
var AutoRenewalBenefits_1 = require("../../../helpers/AutoRenewalBenefits");
var AutomaticRenewalCheckboxWidget = /** @class */ (function (_super) {
    __extends(AutomaticRenewalCheckboxWidget, _super);
    function AutomaticRenewalCheckboxWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var policyHolder = _this.props.engine.getInteraction().policyHolder;
            _this.setState({
                automaticRenewal: policyHolder.automaticRenewal,
                performRenewal: policyHolder.performRenewal
            });
            _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        };
        _this.render = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "automatic-renewal-checkbox__container", children: [_this.renderInputField(), (0, jsx_runtime_1.jsx)(AutomaticRenewalCancellationConfirmationModal_1.AutomaticRenewalCancellationConfirmationModal, { isOpen: _this.state.showModal, onAgreeToAutoRenewal: _this.keepAutomaticRenewal, onConfirmToCancelAutoRenewal: _this.cancelAutomaticRenewal, product: _this.props.interaction.product })] }));
        };
        _this.keepAutomaticRenewal = function () {
            _this.updateInteractionAndState(true);
        };
        _this.cancelAutomaticRenewal = function () {
            _this.updateInteractionAndState(false);
        };
        _this.state = {
            automaticRenewal: false,
            performRenewal: false,
            showModal: false
        };
        return _this;
    }
    AutomaticRenewalCheckboxWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18 auto-renewal-widget home", children: "Auto-renewal makes things a little easier..." }), (0, jsx_runtime_1.jsx)(AutoRenewalBenefits_1.AutoRenewalBenefits, {}), (0, jsx_runtime_1.jsxs)("div", { className: "automatic-renewal-checkbox__input", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0", children: "Prefer not to auto-renew?" }), (0, jsx_runtime_1.jsx)("div", { className: "widget", children: (0, jsx_runtime_1.jsx)(CollapseTextWidget_1.CollapseTextWidget, { summary: "Opt out here", p: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: "falcon-checkbox form-group ".concat(this.getSetting("cssClass", "")), children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", onClick: this.handleOnClickEvent, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this.isChecked()), type: "checkbox", onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onDoubleClick: this.executeNativeEvent, name: this.props.question.name, id: this.props.question.name, checked: this.isChecked() }), (0, jsx_runtime_1.jsxs)("label", { className: "custom-control-label", htmlFor: this.props.question.name, children: [(0, jsx_runtime_1.jsx)("div", { className: "checkbox-big" }), (0, jsx_runtime_1.jsxs)("div", { className: "checkbox-label ".concat(this.getSetting("checkboxLabelCssClass", "")), children: [(0, jsx_runtime_1.jsx)("p", { children: "By automatically renewing your insurance, you can save time next year and ensure that there's no interruption to your cover." }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0", children: "Untick this button to opt out of automatic renewal." })] })] })] }) }) }) }) }) })] })] }));
    };
    AutomaticRenewalCheckboxWidget.prototype.handleOnClickEvent = function (e) {
        e.preventDefault();
        var checked = !this.isChecked();
        this.updateInteractionField(checked);
        this.setState({
            automaticRenewal: checked,
            performRenewal: checked,
            showModal: !checked
        });
    };
    AutomaticRenewalCheckboxWidget.prototype.updateInteractionField = function (checked) {
        journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.engine.getInteraction(), checked.toString());
        journey_services_1.ObjectManipulator.setField("policyHolder.performRenewal", this.props.engine.getInteraction(), checked.toString());
        this.validateInternal(checked);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    AutomaticRenewalCheckboxWidget.prototype.isChecked = function () {
        var val = this.bindFromField(this.props.question.interactionField);
        return val === true || val === "true" || false;
    };
    AutomaticRenewalCheckboxWidget.prototype.updateInteractionAndState = function (checked) {
        this.updateInteractionField(checked);
        this.setState({
            automaticRenewal: checked,
            performRenewal: checked,
            showModal: false
        });
    };
    return AutomaticRenewalCheckboxWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.AutomaticRenewalCheckboxWidget = AutomaticRenewalCheckboxWidget;
//# sourceMappingURL=AutomaticRenewalCheckboxWidget.js.map